<template>
  <section>
    <div class="status"><h2 v-translate>Přiřazené balíčky</h2><h2>&nbsp;({{ entity.channel_packages.length }})</h2></div>
    <table class="vypis">
      <not-sorting-table-header
          v-if="!entity.channel_packages || entity.channel_packages.length > 0"
          :titles="tableTitles"
          :useRight="false"
          :dragDrop="true"
          :checkbox="true"
      />
      <tbody>
      <channel-package-row
          v-for="entity in entity.channel_packages"
          :entity="entity"
          :key="entity.id"
          :selectedEntities="selectedEntities"
          @input="select"
      />
      <tr v-if="!entity.channel_packages || entity.channel_packages.length === 0">
        <td colspan="4">{{ $gettext("Nebyly přiřazeny žádné balíčky.") }}</td>
      </tr>
      </tbody>
    </table>
    <local-list-action-line
        :entities="entity.channel_packages"
        :selected-entities="selectedEntities"
        :multiple-action-options="multipleActionOptions"
        @select-all="toggleSelectAll"
        @run-multiple-action="runMultipleAction"
    ></local-list-action-line>
  </section>
</template>

<script>
import NotSortingTableHeader from "@/components/common/NotSortingTableHeader"
import localTable from "@/components/mixins/local-table"
import ChannelPackageRow from "./ChannelPackageRow";

	export default {
		name: "ChannelPackages",
    mixins: [localTable],
    components: {NotSortingTableHeader, ChannelPackageRow},
		props: {
			entity: Object,
			errorMessages: {
				type: [Array, Object],
				default: function () {
					return []
				},
			},
		},
    computed:{
      tableTitles() {
        return [
          this.$gettext('Název balíčku'),
          this.$gettext('Operátor'),
        ]
      },
      entities(){
        return Object.values(this.entity.channel_packages);
      },
      csvHeaders() {
        return {
          'name': {name: this.$gettext('Název balíčku')},
          'operator_name': {name: this.$gettext('Operátor')},
        }
      }
    }
	}
</script>



// WEBPACK FOOTER //
// src/components/views/businessModels/tabs/ChannelPackageList.vue